import { React, useState } from "react";
import "../App.css";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { useUserAuth } from "../auth";
import { useNavigate } from "react-router-dom";
const GeneratePasswordPage = () => {
	const location = useLocation();
	const { logOut, user, savePassword } = useUserAuth();

	const navigate = useNavigate();
	const handleLogout = async () => {
		try {
			await logOut();
			navigate("/login");
		} catch (error) {
			toast.error(error.message);
		}
	};
	const [sitename, setSitename] = useState(location.state ? location.state.sitename : "");
	const [toggle, setToggle] = useState(false);
	const [username, setUsername] = useState(location.state ? location.state.username : "");
	const [password, setPassword] = useState(location.state ? location.state.password : "");
	const id = location.state ? location.state.id : "";
	const [lengthEl, setLengthEl] = useState(location.state ? location.state.password.length : 8);
	const [uppercaseEl, setUppercaseEl] = useState(true);
	const [lowercaseEl, setLowercaseEl] = useState(true);
	const [numbersEl, setNumbersEl] = useState(true);
	const [symbolsEl, setSymbolsEl] = useState(true);

	function getRandomLower() {
		return String.fromCharCode(Math.floor(Math.random() * 26) + 97);
	}

	function getRandomUpper() {
		return String.fromCharCode(Math.floor(Math.random() * 26) + 65);
	}

	function getRandomNumber() {
		return +String.fromCharCode(Math.floor(Math.random() * 10) + 48);
	}

	function getRandomSymbol() {
		const symbols = "!@#$%^&*(){}[]=<>/,.";
		return symbols[Math.floor(Math.random() * symbols.length)];
	}

	const randomFunc = {
		lower: getRandomLower,
		upper: getRandomUpper,
		number: getRandomNumber,
		symbol: getRandomSymbol,
	};
	function generatePasswordEl(lower, upper, number, symbol, length) {
		let generatedPassword = "";
		const typesCount = lower + upper + number + symbol;
		const typesArr = [{ lower }, { upper }, { number }, { symbol }].filter((item) => Object.values(item)[0]);

		if (typesCount === 0) {
			toast.error("Select atleast 1 option");
		} else {
			for (let i = 0; i < length; i += typesCount) {
				typesArr.forEach((type) => {
					const funcName = Object.keys(type)[0];
					generatedPassword += randomFunc[funcName]();
				});
			}
			const finalPassword = generatedPassword.slice(0, length);
			return finalPassword;
		}
	}

	const checkPassword = async (password) => {
		if (lowercaseEl) {
			if (password.toUpperCase() === password) {
				return true;
			}
		}
		if (uppercaseEl) {
			if (password.toLowerCase() === password) {
				return true;
			}
		}
		if (symbolsEl) {
			const specialChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
			if (!specialChars.test(password)) {
				{
					return true;
				}
			}
		}
		if (lengthEl) {
			if (password.trim().length !== parseInt(lengthEl)) {
				return true;
			}
		}
		if (numbersEl) {
			const res = /\d/.test(password);
			console.log(!res);
			return !res;
		}
		return false;
	};

	const generatePassword = async (e) => {
		e.preventDefault();
		const length = +lengthEl;
		const hasLower = lowercaseEl;
		const hasUpper = uppercaseEl;
		const hasNumber = numbersEl;
		const hasSymbol = symbolsEl;
		setPassword(generatePasswordEl(hasLower, hasUpper, hasNumber, hasSymbol, length));
	};

	function copyText() {
		navigator.clipboard.writeText(password);
		toast.success("Content is successfully copied.");
	}

	const handleSavePassword = async () => {
		if (sitename.trim() === "") {
			toast.error("Site name cannot be empty.");
			return;
		}
		if (username.trim() === "") {
			toast.error("Username cannot be empty.");
			return;
		}
		await checkPassword(password).then(async (err) => {
			if (err) {
				toast.error("Password does not match the set conditions.");
			} else {
				if (id) {
					await toast
						.promise(savePassword(sitename, username, password, id), {
							pending: "Saving password...",
							success: "Password saved successfully.",
						})
						.then(() => {
							navigate("/passwords");
						});
				} else {
					await toast
						.promise(savePassword(sitename, username, password), {
							pending: "Saving password...",
							success: "Password saved successfully.",
							error: "Please, try again.",
						})
						.then(() => {
							navigate("/passwords");
						});
				}
			}
		});
	};
	const Logout = () => (
		<>
			<p style={{ fontSize: "18px", color: "var(--clr-txt)", fontFamily: "Fredoka" }}>Are you sure you want to logout {user.displayName}?</p>
			<button style={{ outline: "none", border: "none", borderRadius: "4px", padding: "6px", color: "#ffffff", fontFamily: "Fredoka", background: "#1da1f2" }} onClick={() => handleLogout()}>
				Yes
			</button>
		</>
	);
	return (
		<>
			<input type="checkbox" id="check" />
			<div className="route-icons">
				<Link className="route-icon" to="/passwords">
					<Icon icon="logos:keycdn-icon" />
				</Link>
				<Link className="route-icon" to="/">
					<Icon icon="noto-v1:notebook" />
				</Link>
				<Link className="route-icon" to="/files">
					<Icon icon="vscode-icons:folder-type-images-opened" />
				</Link>
			</div>
			<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: "linear", duration: 0.08 }} style={{ alignItems: "flex-start", backgroundImage: `url("https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/passwords.svg?alt=media")`, backgroundSize: "600px", backgroundAttachment: "fixed" }}>
				{user != null && (
					<>
						<span className="logoutIcon">
							<Icon onClick={() => toast(<Logout />)} icon="majesticons:logout-half-circle" />
						</span>
						<div className="generatePassword">
							{(toggle || location.state !== null) && (
								<div style={{ marginBottom: "30px" }} className="result-container">
									<label className="passlabel">Site Name</label>
									<input id="result" type="text" style={{ color: "#53bbb6" }} value={sitename} onChange={(e) => setSitename(e.target.value)} required />
								</div>
							)}
							{(toggle || location.state !== null) && (
								<div style={{ marginBottom: "30px" }} className="result-container">
									<label className="passlabel">Site Username</label>
									<input id="result" type="text" style={{ color: "#1da1f2" }} value={username} onChange={(e) => setUsername(e.target.value)} required />
								</div>
							)}
							<div className="result-container">
								<label className="passlabel">Password</label>
								<input id="result" type="text" value={password} onChange={(e) => setPassword(e.target.value)} required />
								<button onClick={() => copyText()} className="bttttn" id="clipboard">
									<Icon icon="akar-icons:copy" />
								</button>
							</div>
							<form onSubmit={generatePassword} className="settings">
								<div className="setting">
									<label>Password length (Max:20)</label>
									<input type="number" value={lengthEl} onChange={(e) => setLengthEl(e.target.value)} id="length" min="4" max="20" required />
								</div>
								<div className="setting">
									<label>Include uppercase letters</label>
									<input className="checkbox" type="checkbox" checked={uppercaseEl} onChange={() => setUppercaseEl(!uppercaseEl)} id="uppercase" />
								</div>
								<div className="setting">
									<label>Include lowercase letters</label>
									<input className="checkbox" type="checkbox" id="lowercase" checked={lowercaseEl} onChange={() => setLowercaseEl(!lowercaseEl)} />
								</div>
								<div className="setting">
									<label>Include numbers</label>
									<input className="checkbox" type="checkbox" id="numbers" checked={numbersEl} onChange={() => setNumbersEl(!numbersEl)} />
								</div>
								<div className="setting">
									<label>Include symbols</label>
									<input className="checkbox" type="checkbox" id="symbols" checked={symbolsEl} onChange={() => setSymbolsEl(!symbolsEl)} />
								</div>
								<div className="btns">
									<button style={{ padding: "8px 15px", borderRadius: "4px" }} className="btn" id="generate">
										Generate password
									</button>
									{password && !toggle && location.state === null && (
										<span onClick={() => setToggle(!toggle)} style={{ padding: "8px 15px", borderRadius: "4px", backgroundColor: "#1da1f2" }} className="btn">
											save
										</span>
									)}
									{(toggle || location.state !== null) && (
										<span onClick={handleSavePassword} style={{ padding: "8px 15px", borderRadius: "4px", backgroundColor: "#1da1f2" }} className="btn">
											Save
										</span>
									)}
								</div>
							</form>
							{/* {toggle && (
								<form onSubmit={handleSavePassword} className="form">
									<div className="form-groups">
										<div className="form-group">
											<input type="text" id="sitename" value={sitename} onChange={(e) => setSitename(e.target.value)} name="name" placeholder="Enter the name of the site" autoComplete="off" required />
											<label>Site name</label>
										</div>
										<div className="form-group">
											<input type="text" value={username} onChange={(e) => setUsername(e.target.value)} id="username" name="username" placeholder="Enter the site username" autoComplete="off" required />
											<label>Username</label>
										</div>
										<div className="form-group">
											<input type="text" value={password} onChange={(e) => setPassword(e.target.value)} id="password" name="password" placeholder="Enter the password" autoComplete="off" required />
											<label>Password</label>
										</div>
									</div>
									<div style={{ marginTop: "15px" }} className="btns">
										<button style={{ padding: "9px 20px", height: "40px" }} type="submit" id="register" className="btn">
											Save Password
										</button>
										<Link className="btn" style={{ textDecoration: "none", padding: "8px 10px", height: "22px", borderRadius: "4px", background: "#ff6666" }} to="/passwords">
											Cancel
										</Link>
									</div>
								</form>
							)} */}
						</div>
					</>
				)}
			</motion.section>
		</>
	);
};

export default GeneratePasswordPage;
